import React from "react"
import { useTranslation } from "react-i18next"

import { isAndroid, isIos } from "@braintree/browser-detection"
import URLParse from "url-parse"

import AppStoreCTA from "../../assets/images/app-store-cta.svg"
import PlayStoreCTA from "../../assets/images/play-store-cta.svg"
import {
  APP_STORE_APP_PAGE_URL,
  PLAY_STORE_APP_PAGE_URL,
} from "../../lib/app-stores"
import { AppLink } from "../app-link"
import Row from "../row"

export function CallToDownloadApp({
  queryParams,
}: {
  queryParams?: Record<string, unknown>
}) {
  const { t } = useTranslation()
  const showPlayStore = PLAY_STORE_APP_PAGE_URL && !isIos()
  const showAppStore = APP_STORE_APP_PAGE_URL && !isAndroid()
  const appStoreUrl = showAppStore
    ? new URLParse(APP_STORE_APP_PAGE_URL, true)
    : null
  const playStoreUrl = showPlayStore
    ? new URLParse(PLAY_STORE_APP_PAGE_URL, true)
    : null

  // Pass on any extra query string parameters to the store pages
  if (queryParams) {
    appStoreUrl?.set("query", { ...queryParams, ...appStoreUrl.query })
    playStoreUrl?.set("query", { ...queryParams, ...playStoreUrl.query })
  }

  return appStoreUrl || playStoreUrl ? (
    <Row justifyContent="center" gap="medium">
      {appStoreUrl ? (
        <AppLink
          id="call-to-download-app-store"
          to={{ type: "url", url: appStoreUrl.toString() }}
          aria-label={t("Get it on the App Store")}
        >
          <img src={AppStoreCTA} height="42px" role="presentation" />
        </AppLink>
      ) : null}
      {playStoreUrl ? (
        <AppLink
          id="call-to-download-play-store"
          to={{ type: "url", url: playStoreUrl.toString() }}
          aria-label={t("Get it on the Play Store")}
        >
          <img src={PlayStoreCTA} height="42px" role="presentation" />
        </AppLink>
      ) : null}
    </Row>
  ) : null
}
